import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import HeroVisual from "@/components/HeroVisual";
import { SERVICES } from "@/data/site";
import { ArrowUpRight, Server, ShieldCheck, Cpu, Barcode, ShoppingBag, Wrench, FileSignature, Network, Monitor, Layers, Boxes } from "lucide-react";

const iconMap = {
  "yazilim-cozumleri": Cpu,
  "pos-sistemleri": Monitor,
  "barkod-sistemleri": Barcode,
  "guvenlik-sistemleri": ShieldCheck,
  "teknik-servis": Wrench,
  "sunucu-kiralama": Server,
  "e-ticaret": ShoppingBag,
  "e-imza-kep": FileSignature,
  "network-kurulum": Network,
};

const accentColor = {
  red: "#FF3B30",
  blue: "#007AFF",
  green: "#34C759",
  black: "#FFFFFF",
};

export default function Services() {
  return (
    <>
      <SEO title="Hizmetler — Pratik Teknoloji" description="Yazılım, POS, barkod, güvenlik, teknik servis, sunucu kiralama, e-ticaret, e-imza ve network altyapısı." />

      <PageHero
        badge="Hizmetler"
        title={<>Tek merkez,</>}
        titleAlt="dokuz uzmanlık alanı."
        subtitle="İşletmenizin tüm bilişim ihtiyaçlarını uçtan uca karşılıyoruz. Yazılımdan donanıma, güvenlikten sunucuya — projeye en uygun çözümü kurumsal güvenceyle sunuyoruz."
        rightSlot={
          <HeroVisual
            accentColor="#FF3B30"
            center={{ icon: <Layers size={36} strokeWidth={1.6} />, topLabel: "Uçtan Uca", bottomLabel: "Çözüm" }}
            cards={[
              { position: "tr", rotate: 4, delay: 0.4, color: "#FF3B30", icon: <Boxes size={16} />, label: "Hizmet", value: "9", sub: "uzmanlık alanı" },
              { position: "ml", rotate: -5, delay: 0.55, color: "#007AFF", icon: <Cpu size={16} />, label: "Yazılım", value: "Mikro", sub: "Logo ve daha fazlası" },
              { position: "br", rotate: 3, delay: 0.7, color: "#34C759", icon: <ShieldCheck size={16} />, label: "Güvenlik", value: "7/24", sub: "izleme & destek" },
            ]}
          />
        }
      />

      <section className="bg-[#0A0A0A] pb-24 md:pb-32 border-t border-white/10 pt-16">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {SERVICES.map((s) => {
              const Icon = iconMap[s.slug] || Server;
              const iconColor = accentColor[s.accent] || "#FFFFFF";
              return (
                <Link
                  to={`/hizmetler/${s.slug}`}
                  key={s.slug}
                  data-testid={`services-list-${s.slug}`}
                  className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] text-white p-8 hover:bg-white/[0.06] hover:border-[#FF3B30]/50 transition-all duration-300 min-h-[280px] flex flex-col"
                >
                  <div className="flex items-start justify-between">
                    <div
                      className="h-14 w-14 rounded-2xl flex items-center justify-center border group-hover:scale-110 transition-transform"
                      style={{ borderColor: `${iconColor}30`, background: `${iconColor}10`, color: iconColor }}
                    >
                      <Icon size={26} strokeWidth={1.8} />
                    </div>
                    <div className="text-xs font-bold tracking-[0.3em] text-white/40">{s.tag}</div>
                  </div>
                  <h3 className="font-display text-3xl font-bold tracking-tight mt-8 text-white">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/60">{s.short}</p>
                  <div className="mt-auto pt-6 inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-white/50 group-hover:text-[#FF3B30] transition-colors">
                    {s.featured ? "Öne Çıkan" : "Detaylar"} <ArrowUpRight size={14} />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
